/* global jQuery, RFI_API_BASE */

// Added to WebPack Entry array:
// import { CrmFormControlApplyDropdownFormRules, CrmFormControlApplyBooleanFormRules } from './rfi-WebResource'
import { formToJSON } from './forms'
import axios from 'axios';

/** Environment configuration */
const rfiAPI = RFI_API_BASE + '/request'
const formName = 'rfi-form'

jQuery(function () {
  setupValidation(formName)
})

const formatData = function (form) {
  const now = new Date()
  const request_date = now.toISOString()
  const elements = form.elements
  const data = formToJSON(elements)
  data.request_date = request_date

  let state = document.getElementById('datatel_stateprovinceid')
  data.datatel_stateprovinceid = state[state['selectedIndex']].text

  let country = document.getElementById('datatel_address1countryid')
  data.datatel_address1countryid = country[country['selectedIndex']].text

  let military_status = document.getElementById('esc_militarystatus')
  data.esc_militarystatus = military_status[military_status['selectedIndex']].text

  let partnership = document.getElementById('esc_partnership')
  data.esc_partnership = partnership[partnership['selectedIndex']].text

  let term = document.getElementById('elcn_anticipatedentrytermid')
  data.elcn_anticipatedentrytermid = term[term['selectedIndex']].text

  let school = document.getElementById('esc_school')
  data.esc_school = school[school['selectedIndex']].text

  let aos = document.getElementById('esc_areaofstudy')
  data.esc_areaofstudy = aos[aos['selectedIndex']].text

  let program = document.getElementById('elcn_academicprogramofinterestid')
  data.elcn_academicprogramofinterestid = program[program['selectedIndex']].text

  Object.keys(data).map(function (key) {
    if (data[key] === 0 || data[key] === '') {
      delete data[key]
    }
  })

  if (data.datatel_internationaladdress && data.datatel_internationaladdress[0] === 'on') {
    data.datatel_internationaladdress = true
    delete data.datatel_stateprovinceid
    delete data.address1_postalcode
  } else {
    data.datatel_internationaladdress = false
    delete data.address1_line3
    delete data.datatel_address1countryid
  }

  return data
}

function sendRequisition (rfiAPI, data) {

  return new Promise(function (resolve, reject) {
    axios({
      method: 'post',
      url: rfiAPI,
      responseType: 'document',
      withCredentials: true,
      data: data
    })
      .then( function(){
        const form = document.getElementById('form')
        form.classList.add('hidden')
        const success = document.getElementById('success')
        success.classList.remove('hidden')
      })
      .catch(function (error) {
        const submitButton = document.getElementById('submitButton')
        submitButton.innerText = 'Submit Information'
        submitButton.removeAttribute('disabled')
        const errorDiv = document.getElementById('error')
        const errorContent = document.getElementById('error_message')
        let errorHtml = '<pre><code>'
        let errorText = ''
        if (typeof error.code !== 'undefined') {
          errorHtml += 'Error code: ' + error.code + '\n'
          errorText += 'Error code: ' + error.code + '; '
        }
        if (typeof error.message !== 'undefined') {
          errorHtml += 'Error message: ' + error.message + '\n'
          errorText += 'Error message: ' + error.message + '; '
        }
        errorHtml += '</code></pre>' + '\n'
        errorContent.innerHTML = errorHtml
        errorDiv.classList.remove('hidden')
        reject(Error('Sending request failed; ' + errorText ))
      })
  })
}

function setupValidation (pageFormId) {
  jQuery.validator.addMethod(
    'lettersonly',
    function (value, element) {
      return this.optional(element) || /^[a-z-. ]+$/i.test(value)
    },
    'Letters and spaces only please'
  )

  jQuery.validator.addMethod(
    'notZero',
    function (value, element) {
      return this.optional(element) || element[element['selectedIndex']].text
    },
    'Please make a selection.'
  )

  const $form = $('#' + pageFormId)
  $form.validate({
    debug: false,
    rules: {
      firstname: {
        // first name
        required: true,
        lettersonly: true
      },
      lastname: {
        // last name
        minlength: 2,
        required: true,
        lettersonly: true
      },
      emailaddress1: {
        // email
        required: true,
        email: true
      },
      address1_telephone1: {
        // phone
        minlength: 3,
        maxlength: 15,
        required: false
      },
      datatel_internationaladdress: {
        // International address, requires address1_line3 & datatel_address1countryid if set.
        // If not set, requires datatel_stateprovinceid and address1_postalcode.
        required: false
      },
      address1_line1: {
        // address line 1
        required: true
      },
      address1_line2: {
        // address line 1
        required: false
      },
      address1_city: {
        // city
        required: true
      },
      datatel_stateprovinceid: {
        // state - required if datatel_internationaladdress is false
        notZero: true,
        required: {
          depends: function () {
            const international = document.getElementById('datatel_internationaladdress')
            return international.checked === false
          }
        }
      },
      address1_postalcode: {
        // zip - required if datatel_internationaladdress is false
        minlength: 3,
        maxlength: 10,
        required: {
          depends: function () {
            const international = document.getElementById('datatel_internationaladdress')
            return international.checked === false
          }
        }
      },
      address1_line3: {
        // address line 3 - required if datatel_internationaladdress is true
        required: {
          depends: function () {
            const international = document.getElementById('datatel_internationaladdress')
            return international.checked === true
          }
        }
      },
      datatel_address1countryid: {
        // country - required if datatel_internationaladdress is true
        notZero: true,
        required: {
          depends: function () {
            const international = document.getElementById('datatel_internationaladdress')
            return international.checked === true
          }
        }
      },
      esc_militarystatus: {
        // Military status
        required: false
      },
      esc_partnership: {
        // Partnership program, if any
        required: false
      },
      esc_eopquestion1information: {
        // EOP Interest
        required: false
      },
      esc_eopquestion2currentstudent: {
        // EOP current student
        required: false
      },
      esc_school: {
        // School
        notZero: true,
        required: true
      },
      elcn_anticipatedentrytermid: {
        // Entry term
        notZero: true,
        required: true
      },
      esc_areaofstudy: {
        // Area of study
        notZero: true,
        required: true
      },
      elcn_academicprogramofinterestid: {
        // Academic program
        notZero: true,
        required: true
      },
    },
    messages: {
      firstname: {
        require: 'Please enter your first name.',
        lettersonly: 'Letters only please'
      },
      lastname: {
        require: 'Please enter your last name.',
        lettersonly: 'Letters only please'
      },
      emailaddress1: 'Please enter a valid email address.',
      address1_line1: 'Please enter an address.',
      address1_city: 'Please enter a city.',
      datatel_stateprovinceid: 'Please select a state or province.',
      address1_postalcode: 'Please enter a zip code.',
      address1_line3: 'Please enter an international address.',
      datatel_address1countryid: 'Please select your country.',
      esc_school: 'Please select a program School.',
      elcn_anticipatedentrytermid: 'Please select your anticipated entry term.',
      esc_areaofstudy: 'Please select an Area of Study.',
      elcn_academicprogramofinterestid: 'Please select a Program of Interest.'
    },
    highlight: function (element) {
      $(element)
        .closest('.form-group')
        .addClass('has-error')
    },
    unhighlight: function (element) {
      $(element)
        .closest('.form-group')
        .removeClass('has-error')
    },
    errorElement: 'span',
    errorClass: 'help-block',
    errorPlacement: function (error, element) {
      if (element.parent('.input-group').length) {
        error.insertAfter(element.parent())
      } else {
        error.insertAfter(element)
      }
    },
    submitHandler: function (form) {
      const $button = $('#' + pageFormId + ' button')
      $button.prop('disabled', true)
      $button.text('Request Submitted...')

      let data = formatData(form)
      sendRequisition(rfiAPI, data)
    }
  })
}
